module.exports = __webpack_public_path__ + "img/shrimps-2.7e7da635.jpg";